import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { getAdClickIds, getRendezVousTask } from "./landingPages"
import { coalesceProductId, getProductIdFromLocation, resolveCampaignIdFromProductId } from "services/landingPageProductId"

// Logique commune aux formulaires des landing pages ISG :
// soumission via useSubmission (le membre de campagne est géré côté flow) puis redirection (useUrlReturn)
const useLandingPage = ({ campaignStatus, formId, lastForm, leadSource, urlKey }) => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn(urlKey)
  const { submission } = useSubmission()

  useSalesforce('ISG')

  // rendezVous : type de rendez-vous choisi (null si le formulaire n'en propose pas)
  const submit = async ({ lead, rendezVous = null, campusLabel = '' }) => {
    setOpenSnackbar(false)
    const defaultDataLead = {
      Division__c: 'ISG France',
      IONISSchool__c: 'ISG',
      LastForm__c: lastForm,
      LeadSource: leadSource,
      RecordTypeId: recordTypeId
    }
    const finalLead = { ...lead, ...getAdClickIds(), ...defaultDataLead }
    const task = rendezVous !== null ? getRendezVousTask(rendezVous, campusLabel) : {}
    try {
      const productId = coalesceProductId(lead?.ProductId, getProductIdFromLocation())
      const campaignId = await resolveCampaignIdFromProductId({ salesforce, productId })

      await submission({
        campaignId,
        formId,
        lead: finalLead,
        campaignStatus,
        ...task,
        utmCookieName: '_ionis_user_data'
      })
      document.location.href = url
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }

  return { submit }
}

export default useLandingPage
